import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import adminStatusService from "../../utils/services/adminStatusService";
import { loginRequest } from "../../utils/MSL/mslConfig";

import necaLogonew from "../../assets/necaLogonew.png";
import { AppContext } from "../../utils/Context/AppContext";
import { useMsal } from "@azure/msal-react";
import NikiBackgroundImage from "../../assets/NikiBackgroundImage.jpg";
import logoNecaNew from "../../assets/logoNecaNew.png";
import { apiRequest } from "../../utils/MSL/mslConfig";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { instance, accounts } = useMsal();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { setLoginLoading, setIsAdmin } = useContext(AppContext);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const wasLoginLoading = sessionStorage.getItem("isLoginLoading") === "true";
    if (location.search && !wasLoginLoading) {
      navigate("/", { replace: true });
    }
  }, [location.search, navigate]);

  useEffect(() => {
    const wasLoginLoading = sessionStorage.getItem("isLoginLoading") === "true";
    if (wasLoginLoading) {
      setLoginLoading(true);
    }

    const handleRedirectResponse = async () => {
      try {
        const response = await instance.handleRedirectPromise();

        if (response) {
          const claims = response.idTokenClaims;

          if (
            !claims?.extension_NECAHasActiveMembership ||
            !claims?.extension_NECAIsNikiUser
          ) {
            localStorage.clear();
            window.location.replace("https://www.neca.asn.au/branch/niki");
            return;
          }

          // store idToken as before
          localStorage.setItem("idToken", response.idToken);
          localStorage.setItem(
            "userName",
            claims?.given_name || response.account?.name
          );
          localStorage.setItem(
            "userId",
            claims?.emails?.[0] || response.account?.username
          );
          localStorage.setItem("state", claims?.extension_NECAAccountChapter);
          localStorage.setItem("userClaims", JSON.stringify(claims));

          // 🔥 NEW: request API access token
          try {
            const apiResp = await instance.acquireTokenSilent({
              ...apiRequest,
              account: response.account,
            });
          } catch (apiErr) {
            console.warn("API token silent acquisition failed:", apiErr);
          }

          const isAdmin = await adminStatusService.getAdminStatus(localStorage.getItem("userId"));
          setIsAdmin(isAdmin);

          navigate(isAdmin ? "/main" : "/chat?new_conversation", {
            replace: true,
          });
        } else {
          const accounts = instance.getAllAccounts();
          if (accounts.length > 0) {
            try {
              const tokenResp = await instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],
              });
              const claims = tokenResp.idTokenClaims;

              if (
                !claims?.extension_NECAHasActiveMembership ||
                !claims?.extension_NECAIsNikiUser
              ) {
                localStorage.clear();
                window.location.replace("https://www.neca.asn.au/branch/niki");
                return;
              }

              localStorage.setItem("idToken", tokenResp.idToken);
              localStorage.setItem(
                "userName",
                claims?.given_name || accounts[0]?.name
              );
              localStorage.setItem(
                "userId",
                claims?.emails?.[0] || accounts[0]?.username
              );
              localStorage.setItem(
                "state",
                claims?.extension_NECAAccountChapter
              );
              localStorage.setItem("userClaims", JSON.stringify(claims));

              // 🔥 NEW: request API access token
              try {
                const apiResp = await instance.acquireTokenSilent({
                  ...apiRequest,
                  account: accounts[0],
                });
              } catch (apiErr) {
                console.warn("API token silent acquisition failed:", apiErr);
              }

              const isAdmin = await adminStatusService.getAdminStatus(
                localStorage.getItem("userId")
              );
              setIsAdmin(isAdmin);

              navigate(isAdmin ? "/main" : "/chat?new_conversation", {
                replace: true,
              });
            } catch (silentErr) {
              console.warn("Silent token acquisition failed:", silentErr);
            }
          }
        }
      } catch (error) {
        console.error("MSAL redirect handling failed:", error);
      } finally {
        sessionStorage.removeItem("isLoginLoading");
        setLoginLoading(false);
      }
    };

    handleRedirectResponse();

    const claims = JSON.parse(localStorage.getItem("userClaims") || "{}");
    if (
      claims.extension_NECAHasActiveMembership === false ||
      claims.extension_NECAIsNikiUser === false
    ) {
      localStorage.clear();
      window.location.replace("https://www.neca.asn.au/branch/niki");
    }
  }, []);

  const handleMsalLogin = async () => {
    try {
      setLoginLoading(true);
      sessionStorage.setItem("isLoginLoading", "true");

      // ✅ Use normal redirect login without 'prompt'
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error("Microsoft login failed:", error);
      setLoginLoading(false);
      sessionStorage.removeItem("isLoginLoading");
    }
  };
  return (
    <>
      <div className="h-full w-full bg-[#005BAA] hidden lg:flex relative flex items-center justify-center md:justify-start ">
        <div className="absolute top-0 w-[90%] lg:w-[65%] h-[97%] bg-white  flex ">
          <img
            src={logoNecaNew}
            alt="neca_logo"
            className="absolute top-5 left-14 h-[40px] 2xl:left-20"
          />
          <div className="h-[400px] w-full md:w-[90%] border border-[#00AEEF] rounded flex items-center justify-center md:justify-start absolute top-1/2 md:left-[7%] transform -translate-y-1/2">
            <div className="h-full w-full relative">
              <div className="h-[15px] w-[15px] bg-[#00AEEF] absolute left-32 top-[-9px] hidden md:block"></div>
              <div className="h-[15px] w-[15px] bg-[#00AEEF] absolute left-96 bottom-[-9px] hidden md:block"></div>
              <div className="h-full w-full flex items-center justify-center">
                <div className="w-full h-[400px] rounded-[6px] flex items-center justify-center md:justify-start pl-0 md:pl-16">
                  <div className="h-fit w-full flex flex-col gap-3 items-center md:items-start text-center md:text-left">
                    <p className="font-tungsten-medium text-[30px] md:text-[38px] leading-[30px] md:leading-[38px] ">
                      Hi, welcome to
                    </p>
                    <p className="text-[#00AEEF] font-tungsten-semibold text-[30px] md:text-[38px] leading-[30px] md:leading-[38px] ">
                      Niki
                    </p>

                    <p className="px-4 md:px-0 max-w-[400px] whitespace-normal break-words text-[15px]">
                      Niki - NECA's Virtual Expert is here to assist with your
                      electrical and communications questions and enquiries.
                    </p>
                    <p className="px-4 md:px-0 max-w-[400px] whitespace-normal break-words text-[15px]">
                      Niki might be the industry’s most advanced AI platform,
                      but our specialist teams are still here to help. If you’d
                      prefer to speak with a member of our team, please call
                      1300 361 099.{" "}
                    </p>

                    <button
                      onClick={handleMsalLogin}
                      className="bg-[#CCDDED] text-[#005BAA] flex items-center gap-3 border bg-opacity-50 border-[#005BAA] text-[14px] font-[600] justify-center h-[40px] w-[250px] rounded-md  max-w-[300px]"
                    >
                      <span>
                        <img
                          src={necaLogonew}
                          alt="neca_logo_new"
                          className="h-5 w-7"
                        />
                      </span>
                      Login with NECA
                    </button>

                    <div className="flex gap-1 text-[14px] mt-4 justify-center md:justify-start">
                      <span className="text-[#7E8B9E]">
                        Don't have an account?
                      </span>
                      <span className="text-[#014489] cursor-pointer">
                        <a
                          className="font-semibold hover:underline"
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.neca.asn.au/branch/join"
                        >
                          Join NECA
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {windowWidth > 1100 && (
          // <div className="h-[85%] w-[50%] m-auto absolute top-1/2 right-[5%] 2xl:right-56 transform -translate-y-1/2 hidden lg:block lg:flex justify-center items-center">
          //   <img
          //     src={NikiBackgroundImage}
          //     alt="login_side_image"
          //     className=" bg-contain rounded-lg"
          //   />
          // </div>
          <div
            className="h-[85%] w-[50%] m-auto absolute top-1/2 right-[3%] 2xl:right-56 transform -translate-y-1/2 hidden bg-white lg:block lg:flex justify-center items-center bg-cover bg-no-repeat bg-center rounded-lg"
            style={{
              backgroundImage: `url(${NikiBackgroundImage})`,
            }}
          ></div>
        )}
      </div>

      <div className="h-full w-full bg-white relative flex flex-col lg:hidden">
        {/* Blue background block */}
        <div className="absolute top-0 right-0 h-[30%] w-[80%] bg-[#005BAA] z-0 hide-under-350" />

        {/* Image section */}
        <div className="absolute top-8 right-4 md:right-11 h-[35%] md:h-[40%] w-[80%] z-10 hide-under-350">
          <div className="relative w-full h-full">
            <div className="absolute top-3 left-0 w-[85%] h-full border-2 border-[#00AEEF] rounded-[10px] z-10" />
            <div className="absolute bottom-0 left-[-15px] w-full h-[85%] border-2 border-[#00AEEF] rounded-[10px] z-20" />
            <div className="relative w-full h-full z-30">
              <img
                src={NikiBackgroundImage}
                className="w-full h-full object-cover rounded-[10px]"
                alt="Login Page"
              />
            </div>
          </div>
        </div>

        {/* Main content */}
        <div className="flex-grow flex items-end pb-14 md:pb-20 z-30 mt-10">
          <div className="w-full px-4 sm:px-8 md:px-16">
            <div className="max-w-md mx-auto space-y-2 space-x-1 text-left">
              <img src={logoNecaNew} alt="necaLogo" className="h-[30px]" />

              <p className="font-tungsten-medium text-[24px] md:text-[40px] leading-tight">
                Hi, welcome to
              </p>

              <p className="text-[#00AEEF] font-tungsten-semibold text-[34px] md:text-[50px] leading-tight">
                Niki
              </p>

              <p className="text-[12px] md:text-[18px] text-[#242424]">
                Niki - NECA's Virtual Expert is here to assist with your
                electrical and communications questions and enquiries.
              </p>

              <p className="text-[12px] md:text-[18px] text-[#242424]">
                Niki might be the industry’s most advanced AI platform, but our
                specialist teams are still here to help. If you’d prefer to
                speak with a member of our team, please call 1300 361 099.
              </p>

              <button
                onClick={handleMsalLogin}
                className="bg-[#CCDDED] bg-opacity-50 text-[#005BAA] font-semibold tracking-wide flex items-center gap-3 h-[38px] md:h-[44px] w-full max-w-[250px] justify-center rounded-md border border-[#005BAA]"
              >
                <img src={necaLogonew} alt="neca_logo2" className="h-5 w-7" />
                Login with NECA
              </button>

              <div className="flex gap-1 text-[14px] justify-start">
                <span className="text-[#7E8B9E]">Don't have an account?</span>
                <a
                  href="https://www.neca.asn.au/branch/join"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#014489] font-semibold hover:underline"
                >
                  Join NECA
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;

export const validateFormInput = (name, value) => {
  switch (name) {
    case "userId": {
      if (value?.length === 0) {
        return "User ID is required.";
      } else {
        return "";
      }
    }
    case "password": {
      if (value?.length === 0) {
        return "Password is required";
      } else {
        return "";
      }
    }

    default: {
      if (value?.length === 0) {
        return `${name} is required`;
      } else {
        return "";
      }
    }
  }
};
